<template>
	<horizontal-stepper
	locale="fr"
	:top-buttons="true"
	:steps="steps"
	@completed-step="completedStep"
	@active-step="isStepActive"
	/>
</template>

<script>
	import HorizontalStepper from 'vue-stepper';

	import CreationCompany from './CreationCompany.vue';
	import CreationAssociate from './CreationAssociate.vue';
	import CreationOptions from './CreationOptions.vue';
	import CreationPayment from './CreationPayment.vue';

	export default {
		components: {
			HorizontalStepper
		},
		data() {
			return {
				steps: [
					{
						icon: 'business',
						name: 'company',
						title: 'Entreprise',
						component: CreationCompany,
						completed: false,
						alreadyCompleted: false
					},
					{
						icon: 'contacts',
						name: 'associate',
						title: 'Associés',
						component: CreationAssociate,
						completed: false,
						alreadyCompleted: false
					},
					{
						icon: 'add',
						name: 'options',
						title: 'Options',
						component: CreationOptions,
						completed: false,
						alreadyCompleted: true
					},
					{
						icon: 'payment',
						name: 'payment',
						title: 'Paiement',
						component: CreationPayment,
						completed: false,
						alreadyCompleted: false
					}
				]
			}
		},
		methods: {
			completedStep(payload) {
				this.steps.forEach((step) => {
					if (step.name === payload.name) {
						step.completed = true;
					}
				})
			},
			isStepActive(payload) {
				this.steps.forEach((step) => {
					if (step.name === payload.name) {
						if(step.completed === true) {
							step.completed = false;
						}
					}
				})
			}
		}
	}
</script>
